/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo } from "react";
import { SessionType } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import "./index.less";
import Context from "@/components/chat/context";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { changeEgovUrl } from "@/utils/tools";
import { time } from "@/components/Joyspace/util";
import IconFont from "@/components/icon";
import { Tooltip, message } from "antd";
import { useHistory } from "react-router-dom";
import { getJoySpacePageLink } from "@jd/focus-desktop-comps/lib/es/utils";

interface IProps {
  message: any;
  sessionType: SessionType;
  sendType: MessageSendType;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
  clsName?: string;
  showFooter?: boolean;
}

function ShareJoyspaceCard(props: IProps) {
  const history = useHistory();
  const { message, sessionType, clsName, showFooter = true } = props;
  const { currentEmployee, userData } = React.useContext(Context);
  const { authInfo: authData, focusSDK, service, appRuntimeEnv } = React.useContext<
    GlobalContextConfig
  >(GlobalContext);
  const dataInfo = lodashGet(message, "data.0.sharecard", {});

  const openCard = useCallback(() => {
    window.open(getJoySpacePageLink(appRuntimeEnv.joyspaceHost, dataInfo));
  }, [dataInfo]);

  return (
    <div className="share-joyspce-item" onClick={openCard}>
      <div className="share-joyspce-item-icon">
        <img src={changeEgovUrl(dataInfo.icon_url as string) || ""} alt="" />
      </div>
      <div className="share-joyspce-item-content">
        <div className="share-joyspce-item_title color-primary">{dataInfo.title}</div>
        <div className="share-joyspce-item_text">{dataInfo.previewText}</div>
        <div className="share-joyspce-item-user">
          {dataInfo?.author && (
            <span className="share-joyspce-item_info">所有者：{dataInfo?.author.name}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ShareJoyspaceCard;
